import { render, staticRenderFns } from "./pip-recongise.vue?vue&type=template&id=0f5c3184&scoped=true"
import script from "./pip-recongise.vue?vue&type=script&lang=js"
export * from "./pip-recongise.vue?vue&type=script&lang=js"
import style0 from "./pip-recongise.vue?vue&type=style&index=0&id=0f5c3184&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f5c3184",
  null
  
)

export default component.exports